import AppConfig, { IS_PROD_ENV } from '@/AppConfig';
import PlumLogger from 'logger';

const logger = new PlumLogger({
    endpoint: AppConfig.NEW_RELIC_LOG_ENDPOINT!,
    serviceName: 'UI-SERVICES-CLAIMS',
    hostName: !import.meta.env.PROD
        ? window.location.hostname
        : 'https://claims.plumhq.com/',
    env: import.meta.env.DEV ? 'DEV' : 'PROD',
    enabled: IS_PROD_ENV,
});

export { logger };
